import { connect } from 'react-redux';
import {
  INBOX_MESSAGE_ITEM_TYPE,
  MESSAGE_REACTION_ADDED,
} from '@core/constants/analytics';
import { analyticsTrackEvent } from '@core/utils/analytics';
import {
  hasCurrentUserReacted,
  reactionForItem,
} from '@core/reactions/selectors';
import * as userSelectors from '@core/selectors/user';
import {
  operationsResponsive as creators,
  selectorsResponsive as inboxSelectors,
} from '../../../../../store/conversations';
import { operations as reactionOperations } from '../../../../../store/reactions';
import Message from './Message';

const mapStateToProps = (state, ownProps) => {
  const { content, createdAt, updatedAt, writer, failed, repliedMessage } =
    inboxSelectors.message(state, ownProps.messageId);

  return {
    content,
    createdAt,
    currentUserId: userSelectors.currentUserId(state),
    updatedAt,
    writerId: writer,
    failed,
    repliedMessage,
    highlighted: inboxSelectors.isMessageHighlighted(state, ownProps.messageId),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  openEditMessage: () => dispatch(creators.openEditMessage(ownProps.messageId)),
  replyToMessage: () => dispatch(creators.replyToMessage(ownProps.messageId)),
  toggleReaction: ({ emojiName }) =>
    // eslint-disable-next-line no-shadow
    dispatch(async (dispatch, getState) => {
      const state = getState();
      const existingReaction = reactionForItem(state, {
        itemId: ownProps.messageId,
        itemType: INBOX_MESSAGE_ITEM_TYPE,
        emojiName,
      });

      // Determines if this is a new reaction (not a toggle-off of an existing one)
      // by checking whether the current user has already reacted with this emoji.
      // Used to fire the analytics event only when a reaction is being added, not removed.
      const isNewlySelectedEmoji = !hasCurrentUserReacted(
        state,
        existingReaction
      );

      await dispatch(
        reactionOperations.toggleReaction({
          itemId: ownProps.messageId,
          itemType: INBOX_MESSAGE_ITEM_TYPE,
          emojiName,
        })
      );

      if (isNewlySelectedEmoji) {
        analyticsTrackEvent(MESSAGE_REACTION_ADDED);
      }
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Message);
